import { useContext } from 'react';

import './styles.css';

import instagram from '../../../assets/icons/instagram.png';
import facebook from '../../../assets/icons/facebook.png';
import useBreakPoint from 'hooks/useBreakPoint';
import usePromoAsset from 'hooks/usePromoAsset';
import UserContext from 'contexts/UserContext';

function Footer() {
  const { currentPromo } = useContext(UserContext);
  const { isBreakpointActive: isMobile } = useBreakPoint();
  const { asset: logo } = usePromoAsset(currentPromo, 'logo.png');

  const bureaucracy = <p>
    Imagens meramente ilustrativas. Promoção autorizada pela SPA/MF Nº 04.047697/2026. Promoção válida de 09/02/2026 a 11/04/2026. Produtos participantes: produtos das linhas Coca-Cola, Therezópolis e Powerade, nas versões de apresentações e embalagens divulgadas no site <a href='https://tobynatorcida.com' target='_blank' rel='noreferrer' className='link-branco-mobile' > www.tobynatorcida.com</a >. Promoção para pessoas jurídicas elegíveis ao Programa de Lealdade Premia, que estejam localizadas e sediadas nas cidades participantes da promoção, situadas nos estados de MG, MS, PR, RJ, RS, SC e SP. Descrição, cidades participantes, produtos participantes, valores dos prêmios e condições de participação, acessando o regulamento da promoção disponível em <a href='https://tobynatorcida.com/regulamento/' target='_blank' rel='noreferrer' className='link-branco-mobile' >www.tobynatorcida.com/regulamento</a>.
  </p>;

  if (isMobile) {
    return (
      <div className='footer-container-mobile'>
        <div className='footer-links-mobile'>
          <a
            href='https://tobynatorcida.com/faq/'
            target='_blank'
            rel='noreferr noreferrer'
          >
            FAQ
          </a>
          <a
            href='https://tobynatorcida.com/regulamento/'
            target='_blank'
            rel='noreferr noreferrer'
          >
            Regulamento
          </a>
        </div>
        <div className='footer-burocracy-mobile'>
          {bureaucracy}
        </div>
        <div className='footer-logo-container-mobile'>
          <img
            alt='logo'
            className='footer-logo-mobile'
            src={logo}
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
          />
        </div>
        <div className='footer-social-mobile'>
          <a
            href='https://www.instagram.com/juntosplusbr/'
            target='_blank'
            rel='noreferr noreferrer'
          >
            <img src={instagram} alt='ig' />
          </a>
          <a
            href='https://www.facebook.com/JuntosPlusBR/'
            target='_blank'
            rel='noreferr noreferrer'
          >
            <img src={facebook} alt='fb' />
          </a>
        </div>
      </div>
    );
  } else {
    return (
      <div className='footer-container'>
        <div className='footer-up'>
          <div className='footer-links'>
            <a
              href='https://tobynatorcida.com/faq/'
              target='_blank'
              rel='noreferr noreferrer'
            >
              FAQ
            </a>
            <a
              href='https://tobynatorcida.com/regulamento/'
              target='_blank'
              rel='noreferr noreferrer'
            >
              Regulamento
            </a>
          </div>
          <div className='footer-social'>
            <a
              href='https://www.instagram.com/juntosplusbr/'
              target='_blank'
              rel='noreferr noreferrer'
            >
              <img src={instagram} alt='ig' />
            </a>
            <a
              href='https://www.facebook.com/JuntosPlusBR/'
              target='_blank'
              rel='noreferr noreferrer'
            >
              <img src={facebook} alt='fb' />
            </a>
          </div>
          <div className='footer-logo-container'>
            <img
              alt='logo'
              className='footer-logo'
              src={logo}
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            />
          </div>
        </div>
        <div className='footer-burocracy'>
          {bureaucracy}
        </div>
      </div>
    );
  }
}

export default Footer;
